import React, { useEffect } from "react";
import SalesForYearChart from "./Charts/SalesForYearChart";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import DashboardCardValues from "./DashboardCardValues";
import ChartCard from "../../components/Cards/ChartCard";
import DashboardCharts from "./DashboardCharts";
import BestSellingProducts from "./BestSellingProducts";
import LatestStatus from "./LatestStatus";
import LatestTransactions from "./LatestTransactions";
import fetchDashboardAnalyticsAction from "@pillvery/redux/dashboard/actions";
import { useDispatch, useSelector } from "react-redux";

const { fetchAnalytics } = fetchDashboardAnalyticsAction;
const user = JSON.parse(localStorage.getItem("user"));

export default function HomeDashboard() {
  const dispatch = useDispatch();
  const { statistics, loading } = useSelector((state) => state.Dashboard);

  useEffect(() => {
    dispatch(
      fetchAnalytics({
        ordersValue: true,
        completedOrders: true,
        completedOrdersPerMonth: true,
        revenueThisMonth: true,
        revenuePerMonth: true,
        params: {},
      })
    );
  }, []);

  return (
    <>
      <Breadcrumb label="Dashboard" />
      <div className="row">
        {/* Columns */}
        <DashboardCardValues statistics={statistics} loading={loading} />
      </div>

      {/* Two Rows in these Components */}
      <DashboardCharts statistics={statistics} loading={loading} />
      <div className="row">
        {/* Columns */}
        <ChartCard
          label="Monthly Orders"
          chart={<SalesForYearChart />}
          cardWidth={8}
        />
        {user?.role === 2 && (
          <LatestStatus statistics={statistics} loading={loading} />
        )}
      </div>

      <div className="row">
        {/* Columns */}
        <BestSellingProducts />
      </div>
      {user?.role === 2 && (
        <div className="row">
          {/* Columns */}
          <LatestTransactions />
        </div>
      )}
    </>
  );
}
